import React from 'react';
import { useTranslation } from 'react-i18next';
import LifecycleTypeTab from './LifecycleTypeTab';
import { getExitReasons, addExitReason, updateExitReason, deleteExitReason } from '../../../../../api/Employee/lifecycleSettings';

const ExitReasonsTab: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LifecycleTypeTab
      title={t('Exit Reasons')}
      description={t('Configure reasons for employee exit such as resignation, retirement, and termination')}
      emptyMessage={t('No exit reasons configured yet')}
      emptyIcon="UserMinus"
      addLabel={t('Add Exit Reason')}
      editLabel={t('Edit Exit Reason')}
      deleteLabel={t('Delete Exit Reason')}
      nameLabel={t('Exit reason name')}
      namePlaceholder={t('e.g., Resignation')}
      successAddMessage={t('Exit reason added successfully')}
      successUpdateMessage={t('Exit reason updated successfully')}
      successDeleteMessage={t('Exit reason deleted successfully')}
      failAddMessage={t('Failed to save exit reason')}
      failDeleteMessage={t('Failed to delete exit reason')}
      deleteConfirmMessage={t('Are you sure you want to delete')}
      duplicateMessage={t('An exit reason with this name already exists')}
      fetchItems={getExitReasons}
      addItem={addExitReason}
      updateItem={updateExitReason}
      deleteItem={deleteExitReason}
      testIdPrefix="exit-reason"
      classification={{
        label: t('Classification'),
        helper: t('Decides whether an employee terminated with this reason is marked Resigned or Terminated. Unspecified falls back to the reason name.'),
        unspecifiedLabel: t('Unspecified'),
        resignationLabel: t('Voluntary (resignation)'),
        terminationLabel: t('Involuntary (termination)'),
        resignationChip: t('Resignation'),
        terminationChip: t('Termination'),
      }}
    />
  );
};

export default ExitReasonsTab;
